/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useMemo } from "react";

import { ComponentLockRule } from "../../helpers/commonStatusHelpers";
import { getIdAzureIntroFormUrl, getIdXboxIntroFormUrl } from "../../helpers/navigationHelpers";
import { useString } from "../../localization/localizationHelpers";
import { Forms, Programs } from "../../models/programsConfig";
import {
  IdAzureApplicationStep,
  IdXboxApplicationStep,
  OnboardingProgram,
} from "../../models/status";
import { FormSummary, FormSummaryFormCardRule } from "../FormSummary";

const formCardID = "IdXboxIntroFormSummary";

type FormIntroductionCardProps = {
  unlockRule: ComponentLockRule;
  formName: Forms;
  getFormUrl: (_subFormId: any) => string;
  formCardRule?: FormSummaryFormCardRule;
};

const FormIntroductionCard = ({
  unlockRule,
  formName,
  getFormUrl,
  formCardRule,
}: FormIntroductionCardProps) => {
  const signInToUnlock = useString("signInToUnlock");
  return (
    <FormSummary
      formName={formName}
      getFormUrl={getFormUrl}
      unlockRule={unlockRule}
      lockRightSideText={signInToUnlock}
      formCardRule={formCardRule}
    />
  );
};

export const IdXboxFormIntroductionCard = () => {
  const idXboxIntroUnlockRule: ComponentLockRule = useMemo(
    () => ({
      program: Programs.IdXbox,
      step: IdXboxApplicationStep.Introduction,
    }),
    []
  );
  return (
    <FormIntroductionCard
      unlockRule={idXboxIntroUnlockRule}
      formName={Forms.IdXboxIntroduction}
      getFormUrl={getIdXboxIntroFormUrl}
      formCardRule={{
        stepsToShow: new Set<IdXboxApplicationStep>([IdXboxApplicationStep.Introduction]),
        program: OnboardingProgram.IdXboxProgram,
        formCardId: formCardID,
      }}
    />
  );
};

export const IdAzureFormIntroductionCard = () => {
  const idAzureIntroUnlockRule: ComponentLockRule = useMemo(
    () => ({
      program: Programs.IdAzure,
      step: IdAzureApplicationStep.Introduction,
    }),
    []
  );
  return (
    <FormIntroductionCard
      unlockRule={idAzureIntroUnlockRule}
      formName={Forms.IdAzureIntroduction}
      getFormUrl={getIdAzureIntroFormUrl}
    />
  );
};
